import { Space, Table, Checkbox } from "antd";
import type { ColumnsType } from "antd/es/table";
import { useTranslation } from "react-i18next";
import { useMutation } from "react-query";
import { getItemComponent } from "../../../../api/itemComponent";
import { Dispatch, SetStateAction, useEffect, useState } from "react";
import { Specification } from "./Item";

interface DataType {
  isComponent: boolean;
  specificationId: number;
  id: number;
  extraCharge: number;
  quantity: number;
  notes: string;
}

interface Props {
  selectedItem: any;
  specifications: Specification[];
  setSpecifications: Dispatch<SetStateAction<Specification[]>>;
}

export const Composition = ({
  selectedItem,
  specifications,
  setSpecifications,
}: Props) => {
  const [t] = useTranslation("common");
  //const dispatch = useDispatch();

  const [formatedComps, setFormatedComps] = useState<DataType[]>();

  const { isLoading, mutateAsync: itemCompsMutation } = useMutation(
    "toppings",
    () => getItemComponent(selectedItem?.itemId)
  );

  useEffect(() => {
    itemCompsMutation().then((res) => {
      setFormatedComps(
        res?.data.map((comp: any) => {
          return {
            comp: comp?.component?.name,
            isComponent: true,
            specificationId: comp.id,
            id: comp?.component?.id,
            extraCharge: 0,
            quantity: 1,
            notes: "Example specification notes",
          };
        })
      );
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedItem]);

  const columns: ColumnsType<DataType> = [
    {
      title: `${t("composition")}`,
      dataIndex: "comp",
      key: "comp",
      className: "table-header",
    },
    {
      title: `${t("select")}`,
      key: "select",
      render: (record) => {
        return (
          <Space size="middle">
            <Checkbox
              defaultChecked={
                !selectedItem.specifications.some(
                  (specification: DataType) =>
                    specification.id === record.id &&
                    specification.isComponent === record.isComponent
                )
              }
              onClick={() => {
                const isIdInArray = specifications?.some((topping: any) => {
                  return (
                    topping.id === record.id &&
                    topping.isComponent === record.isComponent
                  );
                });

                if (isIdInArray) {
                  setSpecifications(
                    specifications.filter((spec: any) => spec.id !== record.id)
                  );
                } else {
                  setSpecifications([
                    ...specifications,
                    {
                      isComponent: record.isComponent,
                      specificationId: record.specificationId,
                      id: record.id,
                      extraCharge: record.extraCharge,
                      quantity: record.quantity,
                      notes: record.notes,
                    },
                  ]);
                }
              }}
            />
          </Space>
        );
      },
    },
  ];
  return (
    <>
      <Table
        columns={columns}
        dataSource={formatedComps}
        loading={isLoading}
        pagination={false}
        rowClassName={(record, index) =>
          index % 2 === 0
            ? "table-row-light table-row"
            : "table-row-dark table-row"
        }
        rowKey={(record) => record.specificationId}
      />
    </>
  );
};
